import type { FC } from "react";
import { Textarea } from "flowbite-react";
import { useTranslation } from "react-i18next";
import { InputValidationResult } from "../../types";
import { getValidationMessage } from "../../helpers/validationHelper";
import { inputSurface } from "@design-system";

interface TextAreaProps {
  id: string;
  placeholder?: string;
  defaultValue?: string | number;
  required?: boolean;
  validation?: InputValidationResult;
  className?: string;
  onInputChanged?: (input: string) => void;
}

export const StyledTextArea: FC<TextAreaProps> = function (
  props: TextAreaProps,
) {
  const { t } = useTranslation(["common"]);

  return (
    <Textarea
      id={props.id}
      className={`text-sm ${inputSurface}`}
      name={props.id}
      placeholder={props.placeholder ?? ""}
      defaultValue={props.defaultValue ?? ""}
      required={props.required ?? false}
      color={
        props.validation?.show &&
        (props.validation?.isMissing || props.validation?.isInvalid)
          ? "failure"
          : ""
      }
      helperText={
        props.validation?.show
          ? getValidationMessage(props.validation, t)
          : ""
      }
      onChange={(e) =>
        props.onInputChanged ? props.onInputChanged(e.target.value) : null
      }
    />
  );
};
